import { serializeFusionError } from '@fusion-advantage/backcompat'
import { replaceApptEncounters } from "../../dal/ldbApptEncounter"
import { apiDevDestroyEncounters } from "../apithunk/apiMgr"
import { AppThunk } from "../appStore"
import { selectDashboardDisplayIdentity } from "../dashboardDataSlice"
import { appError } from "../errorSlice"
import { appSync } from "../syncthunk/syncThunk"
import { SyncType } from "../syncthunk/SyncConfig"
import { selectOpIsBlockingEncounterMgmt } from "../selectDashboardLoading"
import { setSimulateOffline } from "../appSlice"
import { deleteAllDeviceToCloudBlobs } from "../../dal/ldbDeviceToCloudBlob"

interface SplodeArgs {
	// use this if a table replacement is required
	// after sploding on a different device...
	localOnly: boolean
}

export const splode = ({localOnly}: SplodeArgs): AppThunk<Promise<void>> => async (dispatch, getState) => {
	if(getState().app.simulateOffline) {
		if(!confirm('Currently simulating offline— restore connectivity and #splode?')) {
			return
		}
		dispatch(setSimulateOffline(false))
	}
	if(selectOpIsBlockingEncounterMgmt(getState())) {
		alert('A sync is currently in progress; please try again when complete.')
		return
	}
	const upn = selectDashboardDisplayIdentity(getState())?.upn
	if(!upn) {
		dispatch(appError({
			err: serializeFusionError('splode', 'no user identity available')
		}))
		return
	}
	if(!localOnly) {
		const rDestroy = await dispatch(apiDevDestroyEncounters())
		if(rDestroy.isErr()) {
			// error message already displayed,
			// nothing further to do
			return
		}
		const rCleanup = await deleteAllDeviceToCloudBlobs(upn)
		if(rCleanup.isErr()) {
			dispatch(appError({
				err: serializeFusionError('splode', rCleanup.error)
			}))
		}
	}
	const r = await replaceApptEncounters(upn, [])
	if(r.isErr()) {
		dispatch(appError({
			err: serializeFusionError('splode', r.error)
		}))
	}
	dispatch(appSync({
		type: SyncType.Dashboard,
	}))
}
